// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ed73881","455":"a2cae4ea","605":"78a7891d","878":"c6e56f59","977":"d1107e7f"}[chunkId] + ".chunk.js";
};